"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constant = require("../Popover/constant");

var _IconTooltip = _interopRequireDefault(require("./IconTooltip.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__MainWrapper",
  componentId: "sc-hg3cr0-0"
})([""]);

var ToolTipIcon = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__ToolTipIcon",
  componentId: "sc-hg3cr0-1"
})(["display:flex;flex-direction:row;align-items:center;"]);

var StyledHyperLink = _styledComponents.default.a.withConfig({
  displayName: "IconTooltip__StyledHyperLink",
  componentId: "sc-hg3cr0-2"
})(["z-index:1000;"]);

var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__ToolTipContent",
  componentId: "sc-hg3cr0-3"
})(["display:flex;flex-flow:column wrap;"]);

var Title = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__Title",
  componentId: "sc-hg3cr0-4"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.lineHeight.XLarge;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.micro;
});

var Content = _styledComponents.default.div.withConfig({
  displayName: "IconTooltip__Content",
  componentId: "sc-hg3cr0-5"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-top:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily.default;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.small;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.normal;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.greyDarker;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.micro;
});

var IconTooltip = function IconTooltip(props) {
  var accessible = props.accessible,
      theme = props.theme,
      tooltipContent = props.tooltipContent,
      tooltipTitle = props.tooltipTitle,
      iconLink = props.iconLink,
      iconData = props.iconData,
      tooltipData = props.tooltipData;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];

  var isMobile = windowWidth <= parseInt(_constant2.BREAKPOINTS.MOBILE.replace('px', ''), 10);

  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);

  var getToolTipContent = function getToolTipContent() {
    if (tooltipTitle) {
      return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(Title, null, tooltipTitle), /*#__PURE__*/_react.default.createElement(Content, null, tooltipContent));
    }

    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(Content, null, tooltipContent));
  };

  var returnToolTipIconWithLink = function returnToolTipIconWithLink() {
    // eslint-disable-next-line react/prop-types
    var color = iconData.color,
        fontsize = iconData.fontsize,
        type = iconData.type;
    return /*#__PURE__*/_react.default.createElement(StyledHyperLink, {
      href: iconLink,
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(ToolTipIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: color,
      fontsize: fontsize,
      icon: type
    })));
  };

  var returnToolTipIcon = function returnToolTipIcon() {
    // eslint-disable-next-line react/prop-types
    var color = iconData.color,
        fontsize = iconData.fontsize,
        type = iconData.type;
    return /*#__PURE__*/_react.default.createElement(ToolTipIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: color,
      fontsize: fontsize,
      icon: type
    }));
  };

  var getMain = function getMain() {
    // eslint-disable-next-line react/prop-types
    var width = tooltipData.width,
        zindex = tooltipData.zindex;
    return /*#__PURE__*/_react.default.createElement(MainWrapper, null, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      accessible: true,
      asToolTip: true,
      content: getToolTipContent(),
      position: isMobile ? _constant.CONTENT_POSITION.TOP : _constant.CONTENT_POSITION.RIGHT,
      theme: "AIRASIA_CLASSIC",
      enableToolTipHeader: false,
      trigger: isMobile ? _constant.TRIGGERS.click : _constant.TRIGGERS.hover,
      simpleToolTipContent: true,
      width: width,
      zIndex: zindex
    }, iconLink ? returnToolTipIconWithLink() : returnToolTipIcon()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

IconTooltip.propTypes = _IconTooltip.default.PropTypes;
IconTooltip.defaultProps = _IconTooltip.default.DefaultProps;
var _default = IconTooltip;
exports.default = _default;